import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Button,
  VStack,
  Text,
  FormErrorMessage,
  Heading,
} from '@chakra-ui/react';

export function NewService({}) {
  const formik = useFormik({
    initialValues: {
      title: '',
      description: '',
      price: '',
      gallery: '',
    },
    validationSchema: Yup.object({
      title: Yup.string()
        .max(255, 'Must be 255 characters or less')
        .required('Required'),
      description: Yup.string().required('Required'),
      price: Yup.number().typeError('Must be a number').required('Required'),
      gallery: Yup.string().required('Required'),
    }),
    onSubmit: values => {
      console.log('Form data:', values);
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <VStack spacing={4} maxW="1200px" m="auto">
        <Heading ta="left">Create a service</Heading>
        <FormControl
          isInvalid={formik.touched.title && formik.errors.title ? true : false}
        >
          <FormLabel htmlFor="title">Title</FormLabel>
          <Input
            id="title"
            name="title"
            type="text"
            {...formik.getFieldProps('title')}
          />
          <FormErrorMessage>{formik.errors.title}</FormErrorMessage>
        </FormControl>

        <FormControl
          isInvalid={
            formik.touched.description && formik.errors.description
              ? true
              : false
          }
        >
          <FormLabel htmlFor="description">Description (Markdown)</FormLabel>
          <Textarea
            id="description"
            name="description"
            {...formik.getFieldProps('description')}
          />
          <FormErrorMessage>{formik.errors.description}</FormErrorMessage>
        </FormControl>

        <FormControl
          isInvalid={formik.touched.price && formik.errors.price ? true : false}
        >
          <FormLabel htmlFor="price">Price</FormLabel>
          <Input
            id="price"
            name="price"
            type="number"
            step="0.01"
            {...formik.getFieldProps('price')}
          />
          <FormErrorMessage>{formik.errors.price}</FormErrorMessage>
        </FormControl>

        <FormControl
          isInvalid={
            formik.touched.gallery && formik.errors.gallery ? true : false
          }
        >
          <FormLabel htmlFor="gallery">Gallery (URLs, one per line)</FormLabel>
          <Textarea
            id="gallery"
            name="gallery"
            {...formik.getFieldProps('gallery')}
          />
          <FormErrorMessage>{formik.errors.gallery}</FormErrorMessage>
        </FormControl>

        <Button
          mt={4}
          colorScheme="blue"
          isLoading={formik.isSubmitting}
          type="submit"
        >
          Submit
        </Button>
      </VStack>
    </form>
  );
}
